import { Main } from './components';

const Payouts = () => <Main />;

export default Payouts;
